/* eslint-disable */

'use strict';

import _ from 'shared/js/underscore';

export default function (Alpine) {
    Alpine.magic('_', () => _);
}
